import React from "react";
import { BadgeCheck, ArrowRight } from "lucide-react";

function Container({ children, className = "" }) {
  return <div className={`mx-auto w-full max-w-6xl px-4 ${className}`}>{children}</div>;
}

export default function Reports() {
  return (
    <div className="min-h-screen bg-white">
      <Container className="py-10">
        <div className="inline-flex items-center gap-2 rounded-full bg-emerald-50 px-3 py-1 text-xs font-semibold text-emerald-950">
          <BadgeCheck className="h-4 w-4" />
          Reports
        </div>

        <h1 className="mt-4 text-3xl font-semibold tracking-tight sm:text-4xl text-slate-900">
          Premium monthly reports that clients understand
        </h1>
        <p className="mt-2 max-w-2xl text-slate-600">
          Simple, readable reports are a premium feature—users feel confident and stay longer.
        </p>

        <div className="mt-8 rounded-3xl border border-emerald-900/10 bg-white p-7 shadow-sm">
          <div className="text-sm font-semibold text-slate-900">Sample report preview</div>

          <div className="mt-4 grid gap-4 md:grid-cols-3">
            <ReportBox title="Performance" value="+12.4%" note="Last 12 months (example)" />
            <ReportBox title="Allocation" value="60/35/5" note="Equity/Debt/Cash" />
            <ReportBox title="Goal status" value="On track" note="Timeline projection" />
          </div>

          <div className="mt-6 rounded-2xl bg-slate-50 p-6">
            <div className="text-xs text-slate-600">Advisor note</div>
            <div className="mt-2 text-sm text-slate-700">
              “Markets moved positively this month. We recommend maintaining SIP discipline and rebalancing if
              allocation drifts beyond 5%.”
            </div>
          </div>

          <a
            href="/portfolio"
            className="mt-6 inline-flex items-center gap-2 rounded-xl bg-emerald-950 px-4 py-2 text-sm font-semibold text-white hover:bg-emerald-900"
          >
            View Portfolio Dashboard <ArrowRight className="h-4 w-4" />
          </a>
        </div>

        <p className="mt-6 text-xs text-slate-500">
          Later: generate PDFs and email monthly reports automatically.
        </p>
      </Container>
    </div>
  );
}

function ReportBox({ title, value, note }) {
  return (
    <div className="rounded-2xl bg-emerald-50 p-5">
      <div className="text-xs text-emerald-900/70">{title}</div>
      <div className="mt-1 text-2xl font-semibold text-emerald-950">{value}</div>
      <div className="mt-1 text-xs text-emerald-900/70">{note}</div>
    </div>
  );
}
